import ProjectMembersAPI from '../../api/projectMembers';

export const state = {
  records: {},
  uiFlags: {
    isFetching: false,
    isCreating: false,
    isUpdating: false,
    isDeleting: false,
  },
};

export const getters = {
  getMembersByProject: _state => projectId => {
    return _state.records[projectId] || [];
  },
  getUIFlags(_state) {
    return _state.uiFlags;
  },
};

export const actions = {
  async get({ commit }, { projectId }) {
    commit('setUIFlag', { isFetching: true });
    try {
      const { data } = await ProjectMembersAPI.get(projectId);
      commit('setMembers', { projectId, data });
    } finally {
      commit('setUIFlag', { isFetching: false });
    }
  },

  async create({ commit }, { projectId, userId, roles }) {
    commit('setUIFlag', { isCreating: true });
    try {
      const { data } = await ProjectMembersAPI.create(projectId, {
        userId,
        roles,
      });
      commit('addMember', { projectId, data });
      return data;
    } finally {
      commit('setUIFlag', { isCreating: false });
    }
  },

  async update({ commit }, { projectId, id, roles }) {
    commit('setUIFlag', { isUpdating: true });
    try {
      const { data } = await ProjectMembersAPI.update(projectId, id, { roles });
      commit('updateMember', { projectId, data });
      return data;
    } finally {
      commit('setUIFlag', { isUpdating: false });
    }
  },

  async delete({ commit }, { projectId, id }) {
    commit('setUIFlag', { isDeleting: true });
    try {
      await ProjectMembersAPI.delete(projectId, id);
      commit('deleteMember', { projectId, id });
    } finally {
      commit('setUIFlag', { isDeleting: false });
    }
  },
};

export const mutations = {
  setUIFlag(_state, data) {
    _state.uiFlags = { ..._state.uiFlags, ...data };
  },
  setMembers($state, { projectId, data }) {
    $state.records = { ...$state.records, [projectId]: data };
  },
  addMember($state, { projectId, data }) {
    const members = $state.records[projectId] || [];
    $state.records = { ...$state.records, [projectId]: [...members, data] };
  },
  updateMember($state, { projectId, data }) {
    const members = $state.records[projectId] || [];
    $state.records = {
      ...$state.records,
      [projectId]: members.map(member =>
        member.id === data.id ? data : member
      ),
    };
  },
  deleteMember($state, { projectId, id }) {
    const members = $state.records[projectId] || [];
    $state.records = {
      ...$state.records,
      [projectId]: members.filter(member => member.id !== id),
    };
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
